import {openModal} from "../../utilities";
import {toLonLat} from "ol/proj";
import {confirmModal} from "../../confirmModal";
import {InventoryLocationInteractionMode} from "../../app/inventories/locations/interactions/interaction";
import * as $ from "jquery";
import axios from "axios";
import {toastAlert} from "../../toastAlert";
import {BaseContextMenu} from "./BaseContextMenu";

export class GroupHuntingLocationEditorContextMenu extends BaseContextMenu {

    constructor() {
        super();

        if(window._interactionsHandler && window._interactionsHandler.interactions.location) {
            this.addItem({
                name: 'edit_location',
                group: 'edit',
                title: () => {
                    if (!window._interactionsHandler.interactions.location.features.length) {
                        return 'Rysuj obszar'
                    }

                    return window._interactionsHandler.interactions.location.mode === InventoryLocationInteractionMode.EDIT ? 'Zakończ edycję obszaru' : 'Edytuj obszar'
                },
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.location.enabled === false) {
                        return false;
                    }

                    if (window._interactionsHandler.interactions.location.mode === InventoryLocationInteractionMode.DRAW) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'location');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.location.mode === InventoryLocationInteractionMode.EDIT ||
                        window._interactionsHandler.interactions.location.features.length === 0;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.location.toggleInteraction();

                    return true;
                }
            })

            this.addItem({
                name: 'delete_location',
                group: 'edit',
                title: 'Usuń obszar',
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.location.enabled === false) {
                        return false;
                    }

                    if (!window._interactionsHandler.interactions.location.features.length) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'location');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.location.mode === InventoryLocationInteractionMode.EDIT ||
                        window._interactionsHandler.interactions.location.features.length === 0;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.location.toggleDelete(window._interactionsHandler.interactions.location.features[0].get('id'));

                    return true;
                }
            })
        }

        if(window._interactionsHandler && window._interactionsHandler.interactions.observers_line) {
            this.addItem({
                name: 'edit_observers_line',
                group: 'edit',
                title: () => {
                    if (!window._interactionsHandler.interactions.observers_line.features.length) {
                        return 'Rysuj linię obserwacji'
                    }

                    return window._interactionsHandler.interactions.observers_line.mode === InventoryLocationInteractionMode.EDIT ? 'Zakończ edycję linii obserwacji' : 'Edytuj linię obserwacji'
                },
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.observers_line.enabled === false) {
                        return false;
                    }

                    if (window._interactionsHandler.interactions.observers_line.mode === InventoryLocationInteractionMode.DRAW) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'observers_line');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.observers_line.mode === InventoryLocationInteractionMode.EDIT ||
                        !window._interactionsHandler.interactions.observers_line.features.length;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.observers_line.toggleInteraction();

                    return true;
                }
            })

            this.addItem({
                name: 'delete_observers_line',
                group: 'edit',
                title: 'Usuń linię obserwacji',
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.observers_line.enabled === false) {
                        return false;
                    }

                    if (!window._interactionsHandler.interactions.observers_line.features.length) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'observers_line');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.observers_line.mode === InventoryLocationInteractionMode.EDIT ||
                        !window._interactionsHandler.interactions.observers_line.features.length;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.observers_line.toggleDelete(window._interactionsHandler.interactions.observers_line.features[0].get('id'));

                    return true;
                }
            })
        }

        if(window._interactionsHandler && window._interactionsHandler.interactions.beaters_line) {
            this.addItem({
                name: 'edit_beaters_line',
                group: 'edit',
                title: () => {
                    if (!window._interactionsHandler.interactions.beaters_line.features.length) {
                        return 'Rysuj linię naganki'
                    }

                    return window._interactionsHandler.interactions.beaters_line.mode === InventoryLocationInteractionMode.EDIT ? 'Zakończ edycję linii naganki' : 'Edytuj linię naganki'
                },
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.beaters_line.enabled === false) {
                        return false;
                    }

                    if (window._interactionsHandler.interactions.beaters_line.mode === InventoryLocationInteractionMode.DRAW) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'beaters_line');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.beaters_line.mode === InventoryLocationInteractionMode.EDIT ||
                        !window._interactionsHandler.interactions.beaters_line.features.length;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.beaters_line.toggleInteraction();

                    return true;
                }
            })

            this.addItem({
                name: 'delete_beaters_line',
                group: 'edit',
                title: 'Usuń linię naganki',
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.beaters_line.enabled === false) {
                        return false;
                    }

                    if (!window._interactionsHandler.interactions.beaters_line.features.length) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'beaters_line');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.beaters_line.mode === InventoryLocationInteractionMode.EDIT ||
                        !window._interactionsHandler.interactions.beaters_line.features.length;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.beaters_line.toggleDelete(window._interactionsHandler.interactions.beaters_line.features[0].get('id'));

                    return true;
                }
            })
        }

        this.addItem({
            name: 'point',
            group: 'location_points',
            title: (contextMenuFeature) => {
                let editing = contextMenuFeature.getFeaturesAtClickedPosition()
                    .filter(feature => feature.get('type') === 'location_point')
                    .length > 0;

                return editing ? 'Edytuj punkt' : 'Dodaj punkt';
            },
            shouldRender: (contextMenuFeature) => {
                return !contextMenuFeature.getFeaturesAtClickedPosition()
                    .filter(feature => feature.get('type') === 'devices')
                    .length > 0;
            },
            onClick: (contextMenuFeature) => {
                let editing = contextMenuFeature.getFeaturesAtClickedPosition()
                    .filter(feature => feature.get('type') === 'location_point')
                    .length > 0;

                const modal = $('#pointModal');

                modal.find('.modal-title').text(editing ? 'Edycja punktu' : 'Dodawanie punktu');

                let latitude = toLonLat(contextMenuFeature.position)[1].toFixed(4);
                let longitude = toLonLat(contextMenuFeature.position)[0].toFixed(4);
                let name = '';
                let id = '';
                let isNew = true;

                if(editing) {
                    let feature = contextMenuFeature.getFeaturesAtClickedPosition()
                        .find(feature => feature.get('type') === 'location_point')

                    id = feature.get('id');

                    name = $(`[name="points[${id}][name]"]`).val();
                    latitude = $(`[name="points[${id}][latitude]"]`).val();
                    longitude = $(`[name="points[${id}][longitude]"]`).val();
                    isNew = $(`[name="points[${id}][is_new]"]`).val();
                }

                modal.find('[name="id"]').val(id)
                modal.find('[name="name"]').val(name)
                modal.find('[name="latitude"]').val(latitude)
                modal.find('[name="longitude"]').val(longitude)
                modal.find('[name="is_new"]').val(isNew)

                openModal('#pointModal');

                return true;
            }
        })

        // this.addItem({
        //     name: 'huntersPoint',
        //     group: 'hunters',
        //     title: (contextMenuFeature) => {
        //         let editing = contextMenuFeature.getFeaturesAtClickedPosition()
        //             .filter(feature => feature.get('type') === 'hunter')
        //             .length > 0;
        //
        //         return editing ? 'Edytuj stanowisko' : 'Dodaj stanowisko';
        //     },
        //     onClick: (contextMenuFeature) => {
        //         let editing = contextMenuFeature.getFeaturesAtClickedPosition()
        //             .filter(feature => feature.get('type') === 'hunter')
        //             .length > 0;
        //
        //         const modal = $('#hunterModal');
        //
        //         modal.find('.modal-title').text(editing ? 'Edycja stanowiska' : 'Dodawanie stanowiska');
        //
        //         let latitude = toLonLat(contextMenuFeature.position)[1].toFixed(4);
        //         let longitude = toLonLat(contextMenuFeature.position)[0].toFixed(4);
        //         let name = '';
        //         let id = '';
        //         let isNew = true;
        //
        //         if(editing) {
        //             let feature = contextMenuFeature.getFeaturesAtClickedPosition()
        //                 .find(feature => feature.get('type') === 'hunter')
        //
        //             id = feature.get('id');
        //
        //             name = $(`[name="points[${id}][name]"]`).val();
        //             latitude = $(`[name="points[${id}][latitude]"]`).val();
        //             longitude = $(`[name="points[${id}][longitude]"]`).val();
        //             isNew = $(`[name="points[${id}][is_new]"]`).val();
        //         }
        //
        //         modal.find('[name="id"]').val(id)
        //         modal.find('[name="name"]').val(name)
        //         modal.find('[name="latitude"]').val(latitude)
        //         modal.find('[name="longitude"]').val(longitude)
        //         modal.find('[name="is_new"]').val(isNew)
        //
        //         openModal('#hunterModal');
        //
        //         return true;
        //     }
        // })

        let type = JSON.parse(window._location_type);
        if(parseInt(type) === 2){

            this.addItem({
                name: 'useDevice',
                group: 'devices',
                title: 'Użyj',
                shouldRender: (contextMenuFeature) => {
                    return contextMenuFeature.getFeaturesAtClickedPosition()
                        .filter(feature => feature.get('type') === 'devices')
                        .length > 0;
                },
                onClick: async (contextMenuFeature) => {

                    const container2 = $('[data-app-map_interaction_container="hunters"]')
                    const table2 = container2.find('table').DataTable();

                    let hunterPointsEpLayer = contextMenuFeature.epMap.hunterPointsEpLayer;

                    let feature = contextMenuFeature.getFeaturesAtClickedPosition()
                        .find(feature => feature.get('type') === 'devices');

                    let id = feature.get('id');

                    try {
                        const response = await axios.post(window._ADD_HUNTERS_ON_DEVICES.replace('REPLACE_ID', id));

                        if (response.data.code !== 200) {
                            throw new Error();
                        }

                        response.data.spots.forEach(spot => {
                            let id = spot.id;

                            $('body').append(`
                    <input type="hidden" name="hunters[${id}][name]" value="${spot.name}" />
                    <input type="hidden" name="hunters[${id}][latitude]" value="${spot.latitude}" />
                    <input type="hidden" name="hunters[${id}][longitude]" value="${spot.longitude}" />
                    <input type="hidden" name="hunters[${id}][type]" value="${spot.type}" />
                    <input type="hidden" name="hunters[${id}][device_id]" value="${spot.device_id}" />
                    <input type="hidden" name="hunters[${id}][id]" value="${id}" />
                `);

                            let row = $(`
                <tr data-id="${spot.id}">
                    <td class="hunter-name">${spot.name}</td>
                    <td>
                        <button data-id="${spot.id}" type="button" class="btn btn-sm btn-primary btnEditHunterPoint">Edytuj</button>
                        <button data-id="${spot.id}" type="button" class="btn btn-sm btn-danger btnDeleteHunterPoint">Usuń</button>
                    </td>
                </tr>
                `);

                            table2.api().rows.add(row);
                            table2.api().draw();

                            let newFeature = hunterPointsEpLayer.addFeature([
                                parseFloat(String(spot.longitude)),
                                parseFloat(String(spot.latitude))
                            ]);

                            newFeature.set('id', spot.id);
                            newFeature.set('name', spot.name);
                            newFeature.set('device_type', spot.type ? spot.type : 1);
                            newFeature.set('device_id', spot.device_id);
                        });

                       // toastAlert('Pomyślnie dodano stanowiska myśliwych');
                    } catch (err) {
                        toastAlert('Wystąpił błąd podczas dodania stanowisk myśliwych', {type: 'danger'});
                    }

                    return true;
                }
            });

            this.addItem({
                name: 'devicePoint',
                group: 'devices',
                title: (contextMenuFeature) => {
                    let editing = contextMenuFeature.getFeaturesAtClickedPosition()
                        .filter(feature => feature.get('type') === 'devices')
                        .length > 0;

                    return editing ? 'Edytuj urządzenie' : 'Dodaj urządzenie';
                },
                onClick: (contextMenuFeature) => {
                    let editing = contextMenuFeature.getFeaturesAtClickedPosition()
                        .filter(feature => feature.get('type') === 'devices')
                        .length > 0;

                    const modal = $('#deviceModal');

                    modal.find('.modal-title').text(editing ? 'Edycja urządzenia' : 'Dodawanie urządzenia');

                    let latitude = toLonLat(contextMenuFeature.position)[1].toFixed(4);
                    let longitude = toLonLat(contextMenuFeature.position)[0].toFixed(4);
                    let name = '';
                    let id = '';
                    let isNew = true;

                    if(editing) {
                        let feature = contextMenuFeature.getFeaturesAtClickedPosition()
                            .find(feature => feature.get('type') === 'devices')

                        id = feature.get('id');

                        name = $(`[name="devices[${id}][name]"]`).val();
                        latitude = $(`[name="devices[${id}][latitude]"]`).val();
                        longitude = $(`[name="devices[${id}][longitude]"]`).val();
                        isNew = false;
                    }

                    modal.find('[name="id"]').val(id)
                    modal.find('[name="name"]').val(name)
                    modal.find('[name="latitude"]').val(latitude)
                    modal.find('[name="longitude"]').val(longitude)
                    modal.find('[name="is_new"]').val(isNew)

                    const firstOptionValue = modal.find('[name="device_type_id"] option:first').val();
                    modal.find('[name="device_type_id"]').val(firstOptionValue);

                    openModal('#deviceModal');

                    return true;
                }
            })

        }

        this.addItem({
            name: 'delete_point',
            group: 'location_points',
            title: 'Usuń punkt',
            shouldRender: (contextMenuFeature) => {
                return contextMenuFeature.getFeaturesAtClickedPosition()
                    .filter(feature => feature.get('type') === 'location_point')
                    .length > 0;
            },
            onClick: async (contextMenuFeature) => {
                if(await confirmModal('Czy na pewno chcesz usunąć ten punkt?')) {
                    let feature = contextMenuFeature.getFeaturesAtClickedPosition()
                        .find(feature => feature.get('type') === 'location_point');

                    contextMenuFeature
                        .epMap
                        .getEpLayerByName('location_points')
                        .getSource()
                        .removeFeature(feature);

                    let id = feature.get('id');
                    $(`[name="points[${id}][name]"]`).remove();
                    $(`[name="points[${id}][latitude]"]`).remove();
                    $(`[name="points[${id}][longitude]"]`).remove();
                    $(`[name="points[${id}][is_new]"]`).remove();

                    const container = $('[data-app-map_interaction_container="points"]')
                    const table = container.find('table').DataTable()
                    const row = table.$(`tr[data-id="${id}"]`);
                    table.api().row(row).remove().draw();
                }

                return true;
            }
        })

        this.addItem({
            name: 'center',
            group: 'default',
            title: 'Wyśrodkuj do tego miejsca',
            onClick: (contextMenuFeature, epMap) => {
                epMap.map.getView().setCenter(contextMenuFeature.position);

                return true;
            }
        })

        this.addItem({
            name: 'ruler',
            group: 'ruler',
            title: 'Zmierz odległość',
            shouldRender: (contextMenuFeature, epMap) => epMap.ruler != null,
            onClick: (contextMenuFeature, epMap) => {
                epMap.ruler.start(contextMenuFeature.position);

                return true;
            }
        })

        this.addItem({
            name: 'ruler-remove',
            group: 'ruler',
            title: 'Usuń pomiar',
            shouldRender: (contextMenuFeature, epMap) => {
                if(epMap.ruler == null) {
                    return false;
                }

                let features = contextMenuFeature
                    .getFeaturesAtClickedPosition(10)
                    .filter(feature => feature.get('type') === 'ruler-measure');

                return features.length > 0;
            },
            onClick: (contextMenuFeature, epMap) => {
                if(!epMap.ruler) {
                    return false;
                }

                let features = contextMenuFeature
                    .getFeaturesAtClickedPosition(10)
                    .filter(feature => feature.get('type') === 'ruler-measure');

                if(features.length > 0) {
                    epMap.ruler.removeMeasure(features[0].getId());
                }

                return true;
            }
        })

        this.addItem({
            name: 'ruler-clear',
            group: 'ruler',
            title: 'Usuń wszystkie pomiary',
            shouldRender: (contextMenuFeature, epMap) => {
                return epMap.ruler != null && epMap.ruler.getNumberOfMeasurements() > 0;
            },
            onClick: (contextMenuFeature, epMap) => {
                epMap.ruler.clear();

                return true;
            }
        })
    }
}